import { removeCompanyFromRedux } from '@/redux-store/slices/admin/companies';
import { store } from '@/redux-store/store';
import keycloakAxios from '@/services/axios';

export const removeCompany = (id: string) => {
  return keycloakAxios
    .delete(`admin/company/${id}?debug=false`)
    .then((response) => {
      if (response.status >= 300) {
        throw new Error(
          `Error deleting company: Invalid status code: ${response.status}`
        );
      }
      store.dispatch(removeCompanyFromRedux({ companyId: id }));
      return response.data;
    });
};
